import LoginClienteAndComerciante from '../views/shared/login-cliente-and-comerciante/LoginClienteAndComerciante.vue'
import RegistrarNegocio from '../views/shared/RegistrarNegocio.vue'
import LoginExclusivoComercio from '../views/shared/login-cliente-and-comerciante/LoginExclusivoComercio.vue'

export const RouteNames = {
    loginClienteAndComerciante: 'login.clienteAndComerciante'
}

export const routes = [
    {
        path: '/loginClienteYComerciante/volver/:volver/dni/:dni/',
        name: RouteNames.loginClienteAndComerciante,
        component: LoginClienteAndComerciante,
    },
    {
        path: '/registrar-negocio',
        name: 'registrarNegocio',
        component: RegistrarNegocio,
    },
    {
        path: '/auth/comercio',
        name: 'loginExclusivoComercio',
        component: LoginExclusivoComercio,
    },
    {
        path: '/auth/comercio/sumabeneficios/u=:user&p=:password',
        name: 'loginExclusivoComercio',
        component: LoginExclusivoComercio,
    },
]